import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LoadingState } from "../LoadingState.d";
import axios from "axios";
import {
  LocalStorageKey,
  RemoveValueFromLocalStorage,
  SaveValueToLocalStorage,
} from "../../utilities/LocalstorageUtility";
import { User } from "../../@types/User";

interface LoginState {
  loadingState: LoadingState;
  value?: {
    token: string;
    status: number;
    user: User;
    userType: string;
  } | null;
  error: any;
}

const initialState: LoginState = {
  loadingState: LoadingState.IDLE,
  value: undefined,
  error: null,
};

export const automaticLoginUser = createAsyncThunk(
  "Auth/automaticLogin",
  async (params: { instituteId: string }) => {
    
    const response = await axios.post(`/api/v1/auth/checkUserValidAndLogin`, {
        instituteId: params.instituteId,
    });
    const status = response.status;
    if (status == 200) {
      const responseData = response.data;
      SaveValueToLocalStorage(LocalStorageKey.Token, responseData.token);
      return responseData;
    } else return response.data;
  }
);


export const automaticLoginSlice = createSlice({
  name: "Auth/automaticLogin",
  initialState: initialState,
  reducers: {
    logout: (state) => {
      RemoveValueFromLocalStorage(LocalStorageKey.Token);
      RemoveValueFromLocalStorage(LocalStorageKey.User);
      state.value = null;
    },
  }
});

export default automaticLoginSlice.reducer;
